import { vMaska } from 'maska/vue';

export default defineNuxtPlugin((nuxtApp) => {
    console.log('[Maska]: Init.');
    nuxtApp.vueApp.directive('maska', vMaska)
})